document.addEventListener("shopify:section:load", initDribbbleSlider);
document.addEventListener("DOMContentLoaded", initDribbbleSlider);

function initDribbbleSlider() {
  const cdSlider = document.querySelector('.cd-slider');
  if (!cdSlider || cdSlider.classList.contains('slider-ready')) return;

  cdSlider.classList.add('slider-ready');

  const items = cdSlider.querySelectorAll("li");
  const nav = cdSlider.querySelector("nav");

  if (!items.length || !nav) return;

  let autoUpdate = false,
      timeTrans = 4000;

  items[0].className = "current_slide";

  items.forEach(item => {
    const color = item.getAttribute("data-color");
    item.style.backgroundColor = color;
  });

  function updateNavColor() {
    const current = cdSlider.querySelector("li.current_slide");
    const nextColor = (current.nextElementSibling || items[0]).getAttribute("data-color");
    const prevColor = (current.previousElementSibling || items[items.length - 1]).getAttribute("data-color");

    nav.querySelector(".next").style.backgroundColor = nextColor;
    nav.querySelector(".prev").style.backgroundColor = prevColor;
  }

  function moveToSlide(direction) {
    const current = cdSlider.querySelector("li.current_slide");
    const sibling = direction === 'next'
      ? current.nextElementSibling || items[0]
      : current.previousElementSibling || items[items.length - 1];

    const color = sibling.getAttribute("data-color");
    const button = nav.querySelector("." + direction);
    const ripple = document.createElement('span');

    current.className = "";
    sibling.className = "current_slide";

    button.appendChild(ripple);

    const size = Math.max(cdSlider.clientWidth, cdSlider.clientHeight) * 2;
    ripple.style.height = ripple.style.width = `${size}px`;
    ripple.style.backgroundColor = color;

    ripple.addEventListener("transitionend", () => ripple.remove());

    updateNavColor();
  }

  nav.querySelector(".next").addEventListener("click", e => {
    e.preventDefault();
    moveToSlide('next');
  });

  nav.querySelector(".prev").addEventListener("click", e => {
    e.preventDefault();
    moveToSlide('prev');
  });

  updateNavColor();

  if (autoUpdate) {
    setInterval(() => {
      moveToSlide('next');
    }, timeTrans);
  }
}
